/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Docs_Already_ExistInputs */

const en_orders_docs_already_exist = /** @type {(inputs: Orders_Docs_Already_ExistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All documents already exist for this order`)
};

const es_orders_docs_already_exist = /** @type {(inputs: Orders_Docs_Already_ExistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los documentos ya existen para este pedido`)
};

/**
* | output |
* | --- |
* | "All documents already exist for this order" |
*
* @param {Orders_Docs_Already_ExistInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_docs_already_exist = /** @type {((inputs?: Orders_Docs_Already_ExistInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Docs_Already_ExistInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_docs_already_exist(inputs)
	return es_orders_docs_already_exist(inputs)
});